import { styled } from '@mui/material/styles';

export const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  borderRadius: '16px',
  padding: '20px',
  flexDirection: 'column',
  '&.future': {
    backgroundColor: theme.palette.neutrals.beige2
  },
  '&.past': {
    border: `1px solid ${theme.palette.neutrals.beige4}`,
    backgroundColor: theme.palette.neutrals.beige1
  }
}));

export const ItemContent = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: '16px'
}));

export const ItemAction = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'flex-start',
  marginTop: '20px'
}));

export const ShortDate = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '48px',
  height: '48px',
  borderRadius: '50%',
  backgroundColor: theme.palette.brand.mediumGreen,
  color: theme.palette.neutrals.beige1,
  fontSize: '12px',
  fontFamily: 'F Grotesk Demi',
  fontWeight: '600',
  lineHeight: '.9rem',
  letterSpacing: 0
}));

export const Content = styled('div')(() => ({
  flexBasis: 'min-content',
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '10px'
}));

export const Appointment = styled('span')(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px'
}));
